<template>
  <div>
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Loan Waivers ready...</h3>
        </div>
      </div>
    </div>
    <div>
      <div class="card-header">
        <div class="row align-items-center justify-content-between mb-2">
          <div class="col">
            <h1 class="mb-2 font-regular">Loan Waivers</h1>
          </div>
        </div>
        <!-- <slot name="header">
          <h1 class="card-title">Services Tab</h1>
        </slot> -->
      </div>
      <div class="card-content">
        <div class="card-body">
          <CDataTable :items="arr" :fields="waveFields" sorter>
            <template #requested_by="{item}">
              <td>
                {{
                  `${item.requested_by_detail.first_name} ${item.requested_by_detail.last_name}`
                }}
              </td>
            </template>
            <template #time="{item}">
              <td>
                {{ item.created_at | date }}
              </td>
            </template>
            <template #loan_balance="{item}">
              <td>
                {{ item.instant_loan.remaining_balance}}
              </td>
            </template>
            <template #action="{item}">
              <td>
                <!-- two buttoon to approve or dis approve -->
                <button
                  v-if="permissions.includes('treat-wavier') && item.status === 'pending'"
                  class="btn btn-sm btn-success"
                  @click="treatWaiver(item, 'approved')"                  
                >
                  Approve
                </button>
                <button
                  v-if="permissions.includes('treat-wavier') && item.status === 'pending'"
                  class="btn btn-sm btn-danger"
                  @click="treatWaiver(item, 'rejected')"
                >
                  Disapprove
                </button>
                <button  class=" btn btn-warning btn-sm w-auto"
                  @click="openNewTab(item.instant_loan.instant_reference)">
                  View Application
                </button>

              </td>
            </template>
          </CDataTable>
          <CPagination
            :activePage.sync="next_page"
            :pages="total"
            :onActivePageChange="onPageChange()"
          ></CPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "@/services/api.service";
import CPagination from "../../components/CPagination.vue";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
const waveFields = [
  "requested_amount",  
  "approved_amount",
  "loan_balance",
  "status",
  "requested_by",
  "treated_by",
  "created_at",
  "action"
];

export default {
  name: "LoanWaivers",
  components: {
    CDataTable,
    CPagination
  },
  computed: {},
  data() {
    return {
      waveFields,
      pageLoading: true,
      arr: [],
      next_page: 1,
      total: 1,
      current: 1
    };
  },
  methods: {
    async getWaivers(page) {
      console.log("working");
      try {
        const response = await ApiService.get(
          `loan/instant/loan-waviers?page=${page}`
        );
        console.log(response);
        this.arr = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        console.log(error);
      }
    },
    openNewTab(id) {
      const newTabUrl = `/loans/${id}`; // Replace with your desired route path
      window.open(newTabUrl, "_blank");
    },
    onPageChange() {
      console.log(this.next_page);
      if (this.current != this.next_page) {
        this.getWaivers(this.next_page);
      }
    },
    treatWaiver(item, action) {
      Swal.fire({
        title: `Are you sure you want to ${action} this waiver?`,
        showCancelButton: true,
        confirmButtonText: `Yes, ${action} it!`,
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await ApiService.post(
              `loan/instant/treat-wavier`,
              { 
                status: action,
                wavier_reference: item.wavier_reference
              }
            );
            console.log(response);
            this.getWaivers(1);
            Swal.fire("Waiver Treated!", "", "success");
          } catch (error) {
            console.log(error.response);
            let _error = error.response.data;
            ErrorService.displayErrorAlert(_error);
          }
        }
      });
    }
  },
  mounted() {
    this.getWaivers(1);
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
  }
};
</script>

<style scoped></style>
